import { DatePicker as DatePickerInput } from 'antd'
import moment from 'moment'
import { parseISO } from 'date-fns'
import styled from '@emotion/styled'
import { InputProps } from 'antd'
import { useEffect, useState } from 'react'

type DatePickerProps = {
  placeholder?: string
  disabled?: boolean
  label?: string
  value: any
} & Partial<InputProps>

export const DatePicker = (props: DatePickerProps) => {
  const DatePickerAny = DatePickerInput as any
  const [hasValue, setHasValue] = useState(!!props.value)
  const [hasFocus, setHasFocus] = useState(false)
  const [hasDisabled, setHasDisabled] = useState(false)

  useEffect(() => {
    setHasValue(!!props.value)
    setHasDisabled(!!props.disabled)
  }, [props.value, props.disabled])

  return (
    <Container
      className={`${hasFocus ? 'has-focus' : ''}${hasValue ? ' has-value' : ''}${
        hasDisabled ? ' has-disabled' : ''
      }`}
    >
      <label>{props.label}</label>
      <DatePickerAny
        {...props}
        format="DD/MM/YYYY"
        onFocus={(e: any) => {
          setHasFocus(true)
          props.onFocus?.(e)
        }}
        onBlur={(e: any) => {
          setHasFocus(false)
          props.onBlur?.(e)
        }}
        onChange={(e: any) => {
          setHasValue(!!e.target.value)
          props.onChange?.(e)
        }}
      />
    </Container>
  )
}

const Container = styled.div`
  .ant-picker {
    padding: 0 4px 0 0;
    width: 100%;
    border-radius: 5px;
  }
  position: relative;
  transition: all 0.2s ease-in-out;
  label {
    color: #484848c9;
    position: absolute;
    font-size: 14px;
    font-weight: 500;
    z-index: 1;
    top: calc(50% - 10px);
    left: 10px;
    transition: all 0.25s;
  }
  &.has-value,
  &.has-focus {
    label {
      top: -8px;
      left: 10px;
      font-size: 12px;
      background-color: #fff;
      padding: 0 3px;
    }
  }
  &.has-disabled {
    label {
      background-color: #f5f5f5;
    }
  }
  input {
    height: 50px;
    padding: 4px 11px;
    width: 100%;
    font-size: 16px;
    &:not(:disabled) {
      &:focus,
      &:hover {
        border-color: #eb8d00;
        box-shadow: 0 0 0 2px rgba(255, 186, 24, 0.2);
        ::placeholder {
          color: transparent;
        }
      }
    }
  }
`
